"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _MKJKL65Rcjs = require('../__chunks/MKJKL65R.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');



exports.DialogDescription = _MKJKL65Rcjs.DialogDescription; exports.useDialogDescription = _MKJKL65Rcjs.useDialogDescription;
